import {
  DiscountedCashFlowResponseData,
  FinancialsGrowthRequestBody,
  FinancialsGrowthResponseData,
  FormData,
} from '../Config/types'

/**
 * API error with status code and detail message
 */
export class ApiError extends Error {
  constructor(
    public statusCode: number,
    public detail: string
  ) {
    super(`Request failed with error ${statusCode}: ${detail}`)
    this.name = 'ApiError'
  }
}

/**
 * Sort growth data by period in descending order
 */
function sortFinancialsGrowthData(responseData: FinancialsGrowthResponseData): FinancialsGrowthResponseData {
  return {
    ...responseData,
    financials_growths: responseData.financials_growths.map((company) => ({
      ...company,
      mean_growth_rate: company.mean_growth_rate.sort(
        (a, b) => b.period - a.period,
      ),
      growth_rate: company.growth_rate.sort(
        (a, b) => b.period - a.period,
      ),
    })),
  }
}

/**
 * Fetch discounted cash flow valuation data
 */
export const fetchDiscountedCashFlow = async (
  formData: FormData,
  fetchWithAuth: (endpoint: string, data: any) => Promise<Response>
): Promise<DiscountedCashFlowResponseData> => {
  const response = await fetchWithAuth('/intrinsic_value/', formData)
  
  if (!response.ok) {
    const errorData = await response.json()
    throw new ApiError(response.status, errorData['detail'])
  }
  
  return response.json()
}

/**
 * Fetch financials growth data
 */
export const fetchFinancialsGrowth = async (
  requestBody: FinancialsGrowthRequestBody,
  fetchWithAuth: (endpoint: string, data: any) => Promise<Response>
): Promise<FinancialsGrowthResponseData> => {
  const response = await fetchWithAuth('/growth_financials/', requestBody)
  
  if (!response.ok) {
    const errorData = await response.json()
    throw new ApiError(response.status, errorData['detail'])
  }
  
  const data: FinancialsGrowthResponseData = await response.json()
  return sortFinancialsGrowthData(data)
}
